import { collection, getDocs, limit, orderBy, query } from 'firebase/firestore';
import { useState, useEffect } from 'react';
import Spinner from '../components/Spinner';
import { db } from '../firebase';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1560184897-ae75f418493e?auto=format&fit=crop&w=1200&q=80';

export default function Slider() {
  const [listings, setListings] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchListings() {
      try {
        const listingsRef = collection(db, 'listings');
        const q = query(listingsRef, orderBy('timestamp', 'desc'), limit(5));
        const querySnap = await getDocs(q);

        const listingsArr = [];
        querySnap.forEach((doc) => {
          listingsArr.push({
            id: doc.id,
            data: doc.data(),
          });
        });

        setListings(listingsArr);
        setLoading(false);
      } catch (error) {
        console.error('Slider fetch error:', error);
        setListings([]);
        setLoading(false);
      }
    }

    fetchListings();
  }, []);

  if (loading) {
    return (
      <div className="w-full flex justify-center items-center py-10">
        <Spinner />
      </div>
    );
  }

  if (!listings || listings.length === 0) {
    return null; // nothing to show
  }

  return (
    <>
      <h2 className="text-2xl font-bold mt-6 mb-4 text-center">
        Find your dream property with us!
      </h2>

      <Swiper
        modules={[EffectFade, Autoplay, Navigation, Pagination]}
        slidesPerView={1}
        effect="fade"
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4000 }}
        className="h-[300px] md:h-[400px] lg:h-[500px]"
      >
        {listings.map(({ id, data }) => {
          const hasImages =
            data &&
            Array.isArray(data.imgUrls) &&
            data.imgUrls.length > 0;

          const imageUrl = hasImages ? data.imgUrls[0] : FALLBACK_IMAGE;

          return (
            <SwiperSlide
              key={id}
              onClick={() => navigate(`/category/${data.type}/${id}`)}
              className="relative cursor-pointer"
            >
              <div
                className="w-full h-full bg-center bg-cover"
                style={{
                  backgroundImage: `url(${imageUrl})`,
                }}
              />

              <div className="absolute w-full bottom-0 bg-black/60 text-white p-4">
                <p className="font-semibold text-lg truncate">
                  {data.name}
                </p>
                <p className="font-bold">
                  ₹{(data.discountedPrice ?? data.regularPrice)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  {data.type === 'rent' && ' / month'}
                </p>
                <p className="text-sm truncate">{data.address}</p>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
}
